import { CabinProductClass } from "./cabin.constants";

/* eslint-disable @typescript-eslint/no-unsafe-assignment */
export const DATA_LAYER = 'dataLayer';
export const GTM_SCRIPT_ID = 'gtmScript';

export const PAGE_TITLE_DEFAULT = 'Norse Atlantic Airways';
export const UNKNOWN = 'Unknown';
export const NOT_AVAILABLE = 'NA';

export enum GtmEvents {
  PAGE_VIEW = 'Page View',
  PURCHASE = 'eec.purchase',
  PRICE_ACCURACY = 'Price Accuracy',
  FLIGHT_CONVERSION = 'Flight Conversion',
}

export enum GtmProdutCategory {
  FLIGHTS = 'Flights',
  EXTRAS = 'Extras',
}

export enum GtmTravelClass {
  ECONOMY = 'Economy',
  PREMIUMECONOMY = 'Premium Economy',
  BUSINESS = 'Business',
  FIRST = 'First',
}

export enum GtmProductFareVariant {
  EL = 'Economy Light',
  EC = 'Economy Classic',
  EP = 'Economy Flextra',
  PL = 'Premium Light',
  PC = 'Premium Classic',
  PP = 'Premium Flextra',
}

export enum GtmProdutBagVariant {
  CB10 = 'Carry-on',
  CB15 = 'Carry-on 15kg',
  BA15 = 'Light checked',
  BA23 = 'Standard checked',
  BA32 = 'Heavy checked',
  MUSC = 'Musical instrument',
  SURF = 'Surfboard / Kite equipment',
  BULK = 'Bulky baggage *',
  SPEQ = 'Sports equipment',
  BIKE = 'Bike',
}

export enum GtmCurrencyCode {
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
  NOK = 'NOK',
  ZAR = 'ZAR',
  SEK = 'SEK'
}

export enum GtmProductNames {
  BAGS = 'Bags',
  SEATS = 'Seats',
  MEAL_SERVICE_ONE = 'Meal - Service 1',
  MEAL_SERVICE_TWO = 'Meal - Service 2',
  EXTRAS = 'Extras',
}

export enum GtmTripTypes {
  ONEWAY = 'OneWay',
  ROUNDTRIP = 'RoundTrip',
  OTHER = 'Other',
}
